<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getKirbyPage } from "../../../../api/kirby/api"
    import { spaNavigate } from "../../../../functionTools/routing"
    import { getTopicById, lang } from "../../../../store"
    import MedialibImage from "../../../widgets/MedialibImage.svelte"
    import MoreButton from "../../../widgets/MoreButton.svelte"
    import TopicCardEntries from "./TopicCardEntries.svelte"

    let {
        cards,
        section,
    }: {
        cards: TopicBasedItem[]
        section: NavSectionContent
    } = $props()
    let path: string = $state()

    function loadPrimaryPath(currentLang: string) {
        if (!section.primary_link) return
        getKirbyPage(section.primary_link, {
            url: true,
        }).then((page) => {
            if (!page) return
            path = `/${currentLang}/` + page.url.split(`/${currentLang}/`).pop()
        })
    }

    // Top-Level: nur SSR (goja löst Promises synchron)
    if (typeof window === "undefined") loadPrimaryPath(String($lang || ""))

    // $effect: Client + SPA-Sprachwechsel
    $effect(() => {
        loadPrimaryPath(String($lang || ""))
    })

    let hoveredThumbnail = $state(-1)
</script>

{#snippet position(topics: Topic[], i: number)}
    <li class="position">
        <!-- svelte-ignore a11y_no_static_element_interactions -->
        <header
            class="position-thumbnail"
            tabindex="0"
            role="button"
            onclick={() => spaNavigate(`${path}?filters_topic=${topics[0].slug}`)}
            onkeydown={(e) => {
                if (e.key === "Enter" || e.key === " ") spaNavigate(path)
            }}
            onmouseenter={() => (hoveredThumbnail = i)}
            onmouseleave={() => (hoveredThumbnail = -1)}
        >
            <div class="thumbnail-wrapper">
                <MedialibImage id={topics[0].primary_image} alt="Thumbnail" class="default" maxWidth={400} />
                <MedialibImage
                    id={topics[0].hover_image}
                    alt="Thumbnail"
                    maxWidth={400}
                    class="hover {hoveredThumbnail === i ? 'hovered' : ''}"
                />
            </div>
            <div class="thumbnail-overlay">
                <small>{$_("general.topic")}</small>
                <h4>{topics[0].title}</h4>
            </div>
        </header>
        <TopicCardEntries
            topic={topics[0].uuid}
            article_types={section.article_types.split(", ")}
            specific_articles={[]}
        />
        <footer>
            <MoreButton
                size="small"
                text={$_("general.more")}
                path={`${path}?filters_topic=${topics[0].slug}`}
                type="dark"
            />
        </footer>
    </li>
{/snippet}

<ul class="positions">
    {#each cards as card, i}
        {@const topics = getTopicById(card.topic[0])}
        {@render position(topics, i)}
    {/each}
</ul>

<style lang="less" global>
    @import "../../../../css/variables.less";
    ul.positions {
        display: grid;
        gap: 1.2rem;
        grid-template-columns: 1fr 1fr 1fr;
        padding: 2.4rem;

        .position {
            display: flex;
            flex-direction: column;
            gap: 0.9rem;
            .position-thumbnail {
                height: 128px;
                width: 100%;
                cursor: pointer;
                position: relative;

                .thumbnail-overlay {
                    height: 100%;
                    padding: 0.6rem;
                    gap: 0.3rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    z-index: 102;
                    position: relative;

                    h4,
                    small {
                        border-radius: 4px;
                        width: fit-content;
                        color: var(--bright-100);
                    }
                    small {
                        background: var(--brand-100);
                        padding: 2px 0.6rem;
                        text-transform: uppercase;
                        font-size: 0.7rem;
                    }
                    h4 {
                        border-radius: 4px;
                        background: var(--dark-100);
                        padding: 0px 0.6rem;
                    }
                }
                .thumbnail-wrapper {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;

                    img  {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 4px;
                    }
                    .hover {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                        z-index: 100;
                    }
                    .hovered {
                        opacity: 1;
                    }
                    &:hover {
                        .hover {
                            opacity: 1;
                        }
                    }
                }
            }

            footer {
                margin-top: auto;
                border-top: 1px solid var(--dark-20);
                display: flex;
                justify-content: flex-end;
            }
        }
        @media @max-mobile-header {
            display: flex;
            flex-direction: column;
            padding: 0px;

            .position-entries {
                display: none !important;
            }
            footer {
                display: none !important;
            }
        }
    }
</style>
